export class YouTubeHTMLConfig {
    constructor() {
        this.videoId = '';
        this.videoTitle = '';
        this.videoImage = '';
        this.videoCreateDate = '';
        this.channelTitle = '';
        this.channelImage = '';
        this.isLIVE = false;
        this.isStream = false;
        this.streamStartDate = '';
        this.streamEndDate = '';
        this.streamHasBeenAlreadyEnded = false;
        this.streamHasNotStartedYet = false;
        this.isShorts = false;
    }
    serialize() {
        return JSON.stringify(this);
    }
    static deserialize(json) {
        const obj = JSON.parse(json);
        const entry = new YouTubeHTMLConfig();
        entry.videoId = obj.videoId;
        entry.videoTitle = obj.videoTitle;
        entry.videoImage = obj.videoImage;
        entry.videoCreateDate = obj.videoCreateDate;
        entry.channelTitle = obj.channelTitle;
        entry.channelImage = obj.channelImage;
        entry.isLIVE = obj.isLIVE;
        entry.isStream = obj.isStream;
        entry.streamStartDate = obj.streamStartDate;
        entry.streamEndDate = obj.streamEndDate;
        entry.streamHasBeenAlreadyEnded = obj.streamHasBeenAlreadyEnded;
        entry.streamHasNotStartedYet = obj.streamHasNotStartedYet;
        entry.isShorts = obj.isShorts;
        return entry;
    }
    getVideoCreateDate() {
        let createDate = null;
        if (!isNullOrUndefined(this.videoCreateDate) && !this.streamStartDate.isEmpty()) {
            createDate = new Date(this.videoCreateDate);
        }
        const startTime = this.getStreamStartDate();
        if (startTime !== null && createDate !== null) {
            const hours = startTime.getHours();
            const minutes = startTime.getMinutes();
            createDate = this.withAddedHours(createDate, hours);
            createDate = this.withAddedMinutes(createDate, minutes);
            return createDate;
        }
        return null;
    }
    withAddedHours(date, hours) {
        const newDate = new Date(date);
        newDate.setHours(newDate.getHours() + hours);
        return newDate;
    }
    withAddedMinutes(date, minutes) {
        const newDate = new Date(date);
        newDate.setMinutes(newDate.getMinutes() + minutes);
        return newDate;
    }
    getStreamStartDate() {
        if (!isNullOrUndefined(this.streamStartDate) && !this.streamStartDate.isEmpty()) {
            if (this.getStreamEndDate() !== null && this.streamHasNotStartedYet) {
                return new Date(Date.now() - 1 * 60 * 1000);
            }
            return new Date(this.streamStartDate);
        }
        return null;
    }
    getStreamEndDate() {
        if (!isNullOrUndefined(this.streamEndDate) && !this.streamStartDate.isEmpty()) {
            return new Date(this.streamEndDate);
        }
        return null;
    }
    getStreamOnline() {
        const nowDate = new Date();
        const startDate = this.getStreamStartDate();
        const endDate = this.getStreamEndDate();
        if (startDate !== null && nowDate > startDate) {
            if (endDate !== null && nowDate > endDate) {
                return false;
            }
            return true;
        }
        return false;
    }
    update(object) {
        this.videoTitle = object.title;
        this.videoImage = object.thumbnail;
        this.videoCreateDate = object.publishedAt;
        this.channelImage = object.authorThumbnail;
        this.channelTitle = object.author;
        this.streamStartDate = object.streamStartDateTimeString;
        this.streamEndDate = object.streamEndDateTimeString;
        this.isLIVE = object.isLIVE;
        this.isStream = object.isStream;
        this.streamHasBeenAlreadyEnded = object.streamHasBeenAlreadyEnded;
        this.streamHasNotStartedYet = object.streamHasNotStartedYet;
        this.isShorts = object.isShorts;
    }
}
